import { Controller } from "@hotwired/stimulus";

/**
 * Dev-only inbox seeding menu: the header row's "select all" checkbox toggles
 * every kind checkbox, and its count input overwrites every per-kind count.
 */
export default class extends Controller {
  static targets = ["selectAll", "allCount", "kind", "count"];

  declare readonly selectAllTarget: HTMLInputElement;
  declare readonly allCountTarget: HTMLInputElement;
  declare readonly kindTargets: HTMLInputElement[];
  declare readonly countTargets: HTMLInputElement[];

  toggleAll(): void {
    const checked = this.selectAllTarget.checked;
    this.kindTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }

  // Unchecking an individual kind clears the master checkbox; checking the
  // last one sets it.
  syncSelectAll(): void {
    this.selectAllTarget.checked = this.kindTargets.every((checkbox) => checkbox.checked);
  }

  applyCount(): void {
    const value = this.allCountTarget.value;
    if (value === "") return;

    this.countTargets.forEach((input) => {
      input.value = value;
    });
  }
}
